module.exports = __webpack_public_path__ + "assets/img/lastz.caaf1a49.png";